/**
 * Skeleton media auto-loader. Loaded once globally from layout/theme.liquid.
 *
 * When an img or video inside a [data-skeleton] wrapper finishes loading
 * (or errors), the wrapper gets data-loaded="true", which fades the shimmer
 * out and reveals the media.
 *
 * A single capture-phase listener on document catches every element,
 * including ones injected or section-rendered later. We also sweep for
 * already-cached media at init and expose window.themeSkeleton.sweep(scope)
 * for code that builds DOM imperatively (e.g. opening the minicart).
 */
(function () {
  if (window.__skeletonImageLoaderInit) return;
  window.__skeletonImageLoaderInit = true;

  /**
   * Mark the closest skeleton wrapper as loaded.
   * @param {EventTarget|null} target
   */
  function markLoaded(target) {
    if (!(target instanceof HTMLImageElement) && !(target instanceof HTMLVideoElement)) return;
    const wrapper = target.closest('[data-skeleton]');
    if (!wrapper) return;
    wrapper.setAttribute('data-loaded', 'true');
  }

  document.addEventListener('load', (e) => markLoaded(e.target), true);
  document.addEventListener('loadeddata', (e) => markLoaded(e.target), true);
  document.addEventListener('error', (e) => markLoaded(e.target), true);

  /**
   * Sweep a scope for already-loaded media and mark their wrappers.
   * @param {ParentNode} [root=document]
   */
  function sweep(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-skeleton] img, [data-skeleton] video').forEach((el) => {
      if (el.tagName === 'IMG') {
        if (el.complete && el.naturalWidth > 0) markLoaded(el);
      } else if (el.tagName === 'VIDEO') {
        if (el.readyState >= 2) markLoaded(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sweep(), { once: true });
  } else {
    sweep();
  }

  window.themeSkeleton = { sweep };
})();
